// extracted by mini-css-extract-plugin
module.exports = {"qualitySelector":"ez","label":"eA","downloadSize":"eB","selectorWrapper":"eC","selected":"eD"};